import { useFetchGet } from "hooks/fetch/useFetchGet";

export function useGetComponents() {
  const {
    loading: componentsLoading,
    error: componentsError,
    response
  } = useFetchGet("components?size=10000000");

  return {
    componentsLoading,
    componentsError,
    components: response?.results,
    count: response?.count
  };
}
